var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
import { Mutation } from 'vuex-class';
import MainHeader from '~/components/layouts/main/header';
import ApplyContent from '~/components/index/Apply';
import BannerContent from '~/components/trait/Branner';
import { saasForeign } from '~/request/api/Common.js';
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchVal = '';
        _this.currServiceIndex = 0;
        _this.problemList = [
            '问题汇总'
        ];
        _this.problemListItem = [];
        return _this;
    }
    default_1.prototype.getCurren = function (id, index) {
        this.updateHelpMean(id);
        this.currServiceIndex = index;
    };
    default_1.prototype.searchTo = function (a) {
        if (a) {
            this.$router.push('/trait/help/search?key=' + a);
        }
        else {
            this.$message.error('请输入搜索内容');
        }
    };
    default_1.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.getProblemMeanList();
                this.setCurrMenu(4);
                return [2];
            });
        });
    };
    default_1.prototype.getProblemMeanList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var typeList, result, _i, result_1, i, _a, typeList_1, j;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        typeList = [
                            { sys_id: 2, icons: 'icon-kehu' },
                            { sys_id: 3, icons: 'icon-shangcheng' },
                            { sys_id: 4, icons: 'icon-caiwu' },
                            { sys_id: 6, icons: 'icon-order' },
                            { sys_id: 7, icons: 'icon-cangku' },
                            { sys_id: 8, icons: 'icon-wuliu' },
                            { sys_id: 9, icons: 'icon-bangong' },
                            { sys_id: 10, icons: 'icon-app' },
                        ];
                        return [4, saasForeign(this.$axios, { params: 'GetSysInfo' }).selects()];
                    case 1:
                        result = (_b.sent()).data.result;
                        for (_i = 0, result_1 = result; _i < result_1.length; _i++) {
                            i = result_1[_i];
                            for (_a = 0, typeList_1 = typeList; _a < typeList_1.length; _a++) {
                                j = typeList_1[_a];
                                if (i.sys_id === j.sys_id) {
                                    Object.assign(i, j);
                                }
                            }
                        }
                        this.problemListItem = result;
                        return [2];
                }
            });
        });
    };
    default_1.prototype.open = function () {
        this.$refs['ApplyContent'].dialogVisible = true;
    };
    __decorate([
        Mutation('UPDATE_HELP_MEAN')
    ], default_1.prototype, "updateHelpMean", void 0);
    __decorate([
        Mutation('SET_CURR_MENU')
    ], default_1.prototype, "setCurrMenu", void 0);
    default_1 = __decorate([
        Component({
            components: {
                MainHeader: MainHeader,
                ApplyContent: ApplyContent,
                BannerContent: BannerContent,
            },
            layout: 'main',
            middleware: 'auth'
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/layouts/helper/Header.vue
// module id = 0oRc
// module chunks = 1